<form [formGroup]="userFormGroup">
  <div class="container-fluid">
    <div class="row" style="padding-top: 15px">
      <div class="col-md-8 mt-2">
        <h4 [innerHTML]="'PersonalInformations' | translate"></h4>
      </div>
      <div class="col-md-4">
        @if (userFormGroup.enabled) {
          <button
            type="button"
            (click)="updateUser()"
            [disabled]="userFormGroup.invalid"
            class="btn btn-primary btn-sm pull-right"
            [innerHTML]="'Enregistrer' | translate"
          ></button>
          <button
            type="button"
            (click)="cancelEditUser()"
            class="btn btn-danger btn-sm pull-right mr-2"
            [innerHTML]="'Annuler' | translate"
          ></button>
        } @else {
          <button
            type="button"
            (click)="onEditField()"
            class="btn btn-primary btn-sm pull-right"
            [innerHTML]="'Modifier' | translate"
          ></button>
        }
      </div>
    </div>
    <hr />
    <div class="row" *ngIf="this.userFormGroup.getRawValue()">
      <div class="col-md-12">
        <div class="form-group row">
          <app-label class="col required" label="Nom" [required]="true" />
          <div class="col-md-6">
            <input
              type="text"
              [ngClass]="{ 'is-invalid': getErrors('lastName') }"
              formControlName="lastName"
              name="lastName"
              class="form-control"
            />
            @if (getErrors('lastName')) {
              @for (error of getErrorsMessage('lastName'); track error) {
                <small class="text-danger">
                  {{ error | translate: { field: ('lastName' | translate) } }}
                </small>
              }
            }
          </div>
        </div>
        <div class="form-group row">
          <app-label class="col required" label="Prenom" [required]="true" />
          <div class="col-md-6">
            <input
              type="text"
              [ngClass]="{ 'is-invalid': getErrors('firstName') }"
              formControlName="firstName"
              name="firstName"
              class="form-control"
            />
            @if (getErrors('firstName')) {
              @for (error of getErrorsMessage('firstName'); track error) {
                <small class="text-danger">
                  {{ error | translate: { field: ('firstName' | translate) } }}
                </small>
              }
            }
          </div>
        </div>
        <div class="form-group row">
          <label class="col col-form-label required" [innerHTML]="'AdresseMail' | translate"></label>
          <section class="col-md-6">
            <input
              type="text"
              [ngClass]="{ 'is-invalid': getErrors('email') }"
              formControlName="email"
              name="email"
              class="form-control"
            />
            @if (getErrors('email')) {
              @for (error of getErrorsMessage('email'); track error) {
                <small class="text-danger">
                  {{ error | translate: { field: ('email' | translate) } }}
                </small>
              }
            }
          </section>
        </div>
        <div class="form-group row">
          <app-label class="col" label="DefautLanguage" [required]="true" />
          <div class="col-md-6">
            <select formControlName="lang" name="lang" class="form-control">
              @for (lang of SUPPORTED_LANGUAGES; track lang) {
                <option [value]="lang">{{ lang.toUpperCase() | translate }}</option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
